import { render, staticRenderFns } from "./issueAlarm.vue?vue&type=template&id=77963bae&scoped=true&"
import script from "./issueAlarm.vue?vue&type=script&lang=js&"
export * from "./issueAlarm.vue?vue&type=script&lang=js&"
import style0 from "./issueAlarm.vue?vue&type=style&index=0&id=77963bae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77963bae",
  null
  
)

export default component.exports